<ng-template #statWidgets>
  <div class="stat-content flex-grow-0 w-100">
    <div class="row g-3 m-0 stat-row-no-gutter">
    @for (data of statData; track $index) {
      <div class="col-lg-3 col-md-6 mb-3" [class.d-none]="isOtherClass && mobileOnlyTitles.includes(data.title)">
        <app-stat-tile
          [accentColour]="data.accentColour ?? 'primary'"
          [caption]="data.subTitle"
          [icon]="data.icon"
          [label]="data.title"
          suffix="%"
          [value]="data.value">
          <div class="d-flex flex-wrap justify-content-between gap-2 mt-2">
            @for (item of data.subItem; track $index) {
              <span class="fs-12 text-muted"><i class="{{item.icon}} text-{{item.iconClass}} fs-16 align-middle me-1"></i>{{item.label}}</span>
            }
          </div>
          <div statTileBottom class="progress animated-progess rounded-0" style="height: 6px;">
            @for (progress of data.progressBar; track $index) {
              <div
                class="progress-bar {{progress.bgColor}} rounded-0"
                role="progressbar"
                [style.width.%]="progress.width"
              >
              </div>
            }
          </div>
        </app-stat-tile>
      </div>
    }
    </div>
  </div>
</ng-template>

@if (useContainer) {
  @if (visibleContainer) {
    <div class="row" [ngClass]="marginBottom">
      <div class="col-12">
        <div class="border border-success rounded ss-grey-panel">
          <div class="row">
            <div class="col-12">
              <div
                class="alert border-0 alert-primary d-flex justify-content-between align-items-center mb-0"
                role="alert"
              >
                <div class="d-flex align-items-center" style="gap: 8px;">
                  <strong>{{containerTitle}}</strong>
                </div>

                <div class="d-flex align-items-center" style="gap: 6px;">
                  <span
                    *ngIf="!expandContainer && showTitleHintText"
                    class="text-muted"
                    style="font-size: 0.85em;"
                  >
                    Widget Row
                  </span>
                  <i class="fs-5"
                     [attr.data-bs-toggle]="'tooltip'"
                     [attr.data-bs-title]="expandContainer ? 'Collapse' : 'Expand'"
                     [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                     style="cursor: pointer; color: #198754;"
                     (click)="toggleContainerExpansion()">
                  </i>
                  <i *ngIf="allowContainerClose"
                     class="fs-3 bx bx-x"
                     [attr.data-bs-toggle]="'tooltip'"
                     data-bs-title="Close"
                     style="cursor: pointer; color: #dc3545;"
                     (click)="closeContainer()">
                  </i>
                </div>
              </div>
            </div>
          </div>
  
          @if (expandContainer) {
            <div class="row stat-body-row">
              <div class="col-12">
                <div class="w-100 stat-widgets-pad">
                  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
}
